export const API_ENDPOINTS = {
    CUSTOMERS: {
        GET_CUSTOMER_BY_ID: "Customer/GetById",
        SEARCH_CUSTOMER: "Customer/Search",
        EXPORT_CUSTOMER: "Customer/Export",
        SAVE_CUSTOMER: "Customer/Save",
        UPDATE_CUSTOMER: "Customer/Update",
        DELETE_CUSTOMER: "Customer/Delete",
        SEARCH_POLICY_HOLDERS: "PolicyHolder/Search",
        GET_CUSTOMER_BY_DETAIL: "Customer/GetDetailById",
        EXPORT_POLICYHOLDER: "PolicyHolder/Export",
        SEARCH_COMPANY: "Company/Search",
        GET_USERS: "Customer/SearchUserDetail",
        SAVE_USER: "User/Save",
        GET_USER_BY_ID: "User/GetById",
        UPDATE_USER: "User/Update",

    },

    // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    CUSTOMERS: {
        CUSTOMER: ["CustomerSearch", "CustomerDetail", "CustomerBulk", "PolicySearch", "PolicyHolderSearch", "PolicyHolderDetail"],
        CUSTOMER_BULK: ["CustomerBulk"], 
            POLICYHOLDERS: ["PolicyHolderSearch"],
            POLICY: ["PolicyHolderSearch"],
            GET_POLICYHOLDER_DETAIL: ["PolicyHolderDetail"],
            GET_CUSTOMER_DETAIL: ["CustomerDetail"],
             GET_DEPENDENT_HOLDERS: ["PolicyHolderDependent"],
    },

};